import { BuildType } from './ApiService';
import {
    QueryVideosParams,
    StoryVideoModel,
    StoryVideoSearchParams,
    StoryVideoSearchResponse,
    VideosResponse,
} from '@/apiTypes/VideoTypes.ts';

export const videoApiEndpoints = (build: BuildType) => ({
    getVideos: build.query<VideosResponse, QueryVideosParams>({
        query: params => ({
            url: 'videos',
            method: 'POST',
            body: params,
        }),
    }),
    searchStories: build.query<StoryVideoSearchResponse, StoryVideoSearchParams>({
        query: params => ({
            url: 'videos/stories/search',
            method: 'POST',
            body: params,
        }),
    }),
    getStory: build.query<StoryVideoModel, string>({
        query: id => ({
            url: `videos/stories/${encodeURIComponent(id)}`,
            method: 'GET',
        }),
    }),
});
